import axios from 'axios'

export default {
  Api () {
    return axios.create({
      baseURL: `https://fm-energywatch.ad.gatech.edu/skysparkBackend`
    })
  },
  getSkysparkData (inputs) {
    // console.log(inputs)
    return this.Api().post('/',inputs)
  }
}

// inputs = {method: "getLastData", endpoint: "", n: ""}
// OR inputs = {method: "getData", endpoint: "", date: "", rollup: "", interval: ""}

// ~~~~~~~~~~ date options ~~~~~~~~~~~~~
// "today", "yyyy-mm-dd..yyyy-mm-dd", "yesterday", "lastWeek", "lastMonth"

// ~~~~~~~~~ rollup options ~~~~~~~~~~~~
// "min", "max", "sum", "avg"

// ~~~~~~~~~ interval options ~~~~~~~~~~
// "min", "hr", "day", "wk", "mo"

// ~~~~~~~~~` endpoint options ~~~~~~~~~
// Air temperature
// @p:gaTech:r:25389911-6d045878
//
// Building load
// @p:gaTech:r:25168db0-23469c3e
//
// PV generation
// @p:gaTech:r:25168ddb-18f219e7
//
// Net consumption (+ import, - export)
// @p:gaTech:r:251cf88f-be5b0d6b
//
// More weather variables for fun
// Rain total today
// @p:gaTech:r:2538993b-0e1f5ce3
//
// Wind direction
// @p:gaTech:r:2538991f-acc6ece9
//
// Wind speed
// @p:gaTech:r:2538990f-0b0abea4
